module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/24a18c39cf49ac3797806a525e07cd7b.jpg";